import React, { useState } from 'react';
import {
  Button,
  CircularProgress,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  Tooltip,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ReplayIcon from '@mui/icons-material/Replay';

/**
 * Ações da listagem de processos: Abrir + menu ⋯ (Atualizar, PDF, Análise, Excluir, Reabrir).
 */
export default function ProcessoRowActions({
  processo,
  isAdmin,
  excluindo,
  onAbrir,
  onAtualizar,
  onBaixarPdf,
  onAnalise,
  onExcluir,
  onReabrir,
  podeAtualizar = true,
  podeReabrir = false,
  reabrindo = false,
  mensagemSemPermissao = '',
}) {
  const [anchor, setAnchor] = useState(null);
  const fechar = () => setAnchor(null);
  const temPdfFinal = Boolean(processo?.documentoFinalUrl);
  const isRejeitado = String(processo?.status || '').toUpperCase() === 'REJEITADO';

  return (
    <Stack direction="row" spacing={0.5} alignItems="center" justifyContent="flex-end" onClick={(e) => e.stopPropagation()}>
      <Button
        size="small"
        variant="outlined"
        startIcon={<VisibilityIcon fontSize="small" />}
        onClick={() => onAbrir(processo)}
        sx={{ textTransform: 'none', borderRadius: 2, whiteSpace: 'nowrap' }}
      >
        Abrir
      </Button>
      <Tooltip title="Mais ações">
        <IconButton size="small" onClick={(e) => setAnchor(e.currentTarget)}>
          <MoreVertIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={fechar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        {!isRejeitado && (
          <Tooltip title={!podeAtualizar ? mensagemSemPermissao || 'Sem permissão nesta etapa' : ''} placement="left">
            <span>
              <MenuItem
                disabled={!podeAtualizar}
                onClick={() => {
                  if (!podeAtualizar) return;
                  fechar();
                  onAtualizar(processo);
                }}
              >
                <ListItemIcon>
                  <EditIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Atualizar processo</ListItemText>
              </MenuItem>
            </span>
          </Tooltip>
        )}
        {isRejeitado && podeReabrir && typeof onReabrir === 'function' && (
          <MenuItem
            disabled={reabrindo}
            onClick={() => {
              fechar();
              onReabrir(processo);
            }}
          >
            <ListItemIcon>
              {reabrindo ? <CircularProgress size={18} /> : <ReplayIcon fontSize="small" color="primary" />}
            </ListItemIcon>
            <ListItemText>Reabrir processo</ListItemText>
          </MenuItem>
        )}
        {temPdfFinal && (
          <MenuItem
            onClick={() => {
              fechar();
              onBaixarPdf(processo);
            }}
          >
            <ListItemIcon>
              <PictureAsPdfIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Baixar PDF consolidado</ListItemText>
          </MenuItem>
        )}
        <MenuItem
          onClick={() => {
            fechar();
            onAnalise(processo);
          }}
        >
          <ListItemIcon>
            <CompareArrowsIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Análise comparativa</ListItemText>
        </MenuItem>
        {isAdmin && (
          <MenuItem
            disabled={excluindo}
            onClick={() => {
              fechar();
              onExcluir(processo);
            }}
            sx={{ color: 'error.main' }}
          >
            <ListItemIcon>
              {excluindo ? (
                <CircularProgress size={18} />
              ) : (
                <DeleteOutlineIcon fontSize="small" color="error" />
              )}
            </ListItemIcon>
            <ListItemText>Excluir</ListItemText>
          </MenuItem>
        )}
      </Menu>
    </Stack>
  );
}
